import React from "react";
import { useTranslation } from "react-i18next";
import { BarChartOutlined } from "@ant-design/icons";
import styles from "./InsufficientDataState.module.scss";

/**
 * GenAI widget body when scoped reviews are below the analysis threshold.
 * Stateless — all values come from props (API payload or scoped review snapshot).
 */
export default function InsufficientDataState({
  currentCount,
  requiredCount,
  className,
}) {
  const { t } = useTranslation();
  const current = Number.isFinite(Number(currentCount))
    ? Math.max(0, Math.round(Number(currentCount)))
    : 0;
  const required = Number.isFinite(Number(requiredCount))
    ? Math.max(1, Math.round(Number(requiredCount)))
    : 1;
  const progressPct = Math.min((current / required) * 100, 100);

  return (
    <div className={[styles.root, className].filter(Boolean).join(" ")}>
      <div className={styles.panel}>
        <div className={styles.iconWrap}>
          <BarChartOutlined className={styles.icon} aria-hidden />
        </div>
        <div className={styles.content}>
          <p className={styles.title}>{t("welcome.insufficientDataTitle")}</p>
          <p className={styles.description}>
            {t("welcome.insufficientDataDescription", {
              current,
              required,
            })}
          </p>
          <div className={styles.progressRow}>
            <div className={styles.progressTrack}>
              <div
                className={styles.progressFill}
                style={{ width: `${progressPct}%` }}
              />
            </div>
            <span className={styles.progressLabel}>
              {t("welcome.insufficientDataProgress", {
                current,
                required,
              })}
            </span>
          </div>
        </div>
      </div>
      <p className={styles.footer}>{t("welcome.insufficientDataFooter")}</p>
    </div>
  );
}
